/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import type { Provider, TransactionRequest } from "@ethersproject/providers"
import { Contract, ContractFactory, Overrides, Signer, utils } from "ethers"
import type { BridgeEndpoint, BridgeEndpointInterface } from "../BridgeEndpoint"
import type { PromiseOrValue } from "../common"

const _abi = [
  {
    inputs: [],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address[]",
        name: "_allowed",
        type: "address[]",
      },
    ],
    name: "AddAllowlistEvent",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "bool",
        name: "allowlist",
        type: "bool",
      },
    ],
    name: "AllowlistEvent",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "token",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "collectAmount",
        type: "uint256",
      },
    ],
    name: "CollectAccruedFeeEvent",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint8",
        name: "version",
        type: "uint8",
      },
    ],
    name: "Initialized",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "Paused",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address[]",
        name: "_removed",
        type: "address[]",
      },
    ],
    name: "RemoveAllowlistEvent",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "previousAdminRole",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "newAdminRole",
        type: "bytes32",
      },
    ],
    name: "RoleAdminChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "RoleGranted",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "RoleRevoked",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "token",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "feePct",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "minFee",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "minAmount",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "maxAmount",
        type: "uint256",
      },
    ],
    name: "SetApprovedTokenEvent",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "token",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "minFee",
        type: "uint256",
      },
    ],
    name: "SetMinFeePerTokenEvent",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "requiredValidators",
        type: "uint256",
      },
    ],
    name: "SetRequiredValidatorsEvent",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "bytes32",
        name: "orderHash",
        type: "bytes32",
      },
      {
        indexed: false,
        internalType: "bytes32",
        name: "salt",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "recipient",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "token",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "TransferToUnwrapEvent",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "token",
        type: "address",
      },
      {
        indexed: false,
        internalType: "string",
        name: "settle",
        type: "string",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "fee",
        type: "uint256",
      },
    ],
    name: "TransferToWrapEvent",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "Unpaused",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "token",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "WithdrawBalanceEvent",
    type: "event",
  },
  {
    inputs: [],
    name: "APPROVED_TOKEN",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "DEFAULT_ADMIN_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "MAX_REQUIRED_VALIDATORS",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "RELAYER_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "VALIDATOR_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "accruedFeePerToken",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "_allowed",
        type: "address[]",
      },
    ],
    name: "addAllowlist",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "allowlist",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "allowlisted",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "burnable",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address",
      },
    ],
    name: "collectAccruedFee",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "domainSeparatorV4",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "feePctPerToken",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
    ],
    name: "getRoleAdmin",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "uint256",
        name: "index",
        type: "uint256",
      },
    ],
    name: "getRoleMember",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
    ],
    name: "getRoleMemberCount",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "grantRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "added",
        type: "address[]",
      },
    ],
    name: "grantValidators",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "hasRole",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "structHash",
        type: "bytes32",
      },
    ],
    name: "hashTypedDataV4",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        internalType: "string",
        name: "name",
        type: "string",
      },
      {
        internalType: "string",
        name: "version",
        type: "string",
      },
      {
        internalType: "uint256",
        name: "_requiredValidators",
        type: "uint256",
      },
    ],
    name: "initialize",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "maxAmountPerToken",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "minAmountPerToken",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "minFeePerToken",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "offAllowlist",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "onAllowlist",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    name: "orderSent",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "orderValidatedBy",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "pause",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "paused",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "_removed",
        type: "address[]",
      },
    ],
    name: "removeAllowlist",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "renounceRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "requiredValidators",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "revokeRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "removed",
        type: "address[]",
      },
    ],
    name: "revokeValidators",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address",
      },
      {
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
      {
        internalType: "bool",
        name: "isBurnable",
        type: "bool",
      },
      {
        internalType: "uint256",
        name: "feePct",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "minFee",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "minAmount",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "maxAmount",
        type: "uint256",
      },
    ],
    name: "setApprovedToken",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_token",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_minFee",
        type: "uint256",
      },
    ],
    name: "setMinFeePerToken",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_requiredValidators",
        type: "uint256",
      },
    ],
    name: "setRequiredValidators",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address",
      },
      {
        internalType: "address",
        name: "recipient",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        internalType: "bytes32",
        name: "salt",
        type: "bytes32",
      },
      {
        components: [
          {
            internalType: "bytes32",
            name: "orderHash",
            type: "bytes32",
          },
          {
            internalType: "address",
            name: "signer",
            type: "address",
          },
          {
            internalType: "bytes",
            name: "signature",
            type: "bytes",
          },
        ],
        internalType: "struct BridgeEndpoint.SignaturePackage[]",
        name: "proofs",
        type: "tuple[]",
      },
    ],
    name: "transferToUnwrap",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        internalType: "string",
        name: "settleData",
        type: "string",
      },
    ],
    name: "transferToWrap",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "unpause",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "withdrawBalance",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
] as const

const _bytecode =
  "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"

type BridgeEndpointConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>

const isSuperArgs = (
  xs: BridgeEndpointConstructorParams,
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1

export class BridgeEndpoint__factory extends ContractFactory {
  constructor(...args: BridgeEndpointConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args)
    } else {
      super(_abi, _bytecode, args[0])
    }
  }

  override deploy(
    overrides?: Overrides & { from?: PromiseOrValue<string> },
  ): Promise<BridgeEndpoint> {
    return super.deploy(overrides || {}) as Promise<BridgeEndpoint>
  }
  override getDeployTransaction(
    overrides?: Overrides & { from?: PromiseOrValue<string> },
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {})
  }
  override attach(address: string): BridgeEndpoint {
    return super.attach(address) as BridgeEndpoint
  }
  override connect(signer: Signer): BridgeEndpoint__factory {
    return super.connect(signer) as BridgeEndpoint__factory
  }

  static readonly bytecode = _bytecode
  static readonly abi = _abi
  static createInterface(): BridgeEndpointInterface {
    return new utils.Interface(_abi) as BridgeEndpointInterface
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider,
  ): BridgeEndpoint {
    return new Contract(address, _abi, signerOrProvider) as BridgeEndpoint
  }
}
